import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on. Kept out
 * of the slice's reducers: they trigger side effects (fetch / create / revoke),
 * not state transitions (the saga owns the resulting `load*` / `create*` /
 * `revoke*` ones).
 */

/** Load every API key (dispatched by the page on mount). */
export const apiKeysRequested = createAction('apiKeys/apiKeysRequested');

/** Create a new key with the given name (dispatched from the create dialog). */
export const createKeyRequested = createAction<{ name: string }>('apiKeys/createKeyRequested');

/** Revoke a key by id (dispatched from the row action). */
export const revokeKeyRequested = createAction<string>('apiKeys/revokeKeyRequested');
